import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ViewContainerRef,
  ComponentFactoryResolver,
  Type,
  ChangeDetectorRef,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { faCity } from "@fortawesome/free-solid-svg-icons";
import { FieldOption } from "src/app/shared-utility/common/field-option.enum";
import { Address } from "src/app/shared-utility/models/address.model";
import { Facility } from "src/app/shared-utility/models/facility.model";
import { Phone } from "src/app/shared-utility/models/phone.model";
import { SharedFormService } from "src/app/shared-utility/services/shared-form.service";
import { SharedStateService } from "src/app/shared-utility/services/shared-state.service";
import { PhysicianLocaleFormComponent } from "../physician-locale-form/physician-locale-form.component";
import { HostListener } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Contact } from "src/app/shared-utility/models/contact.model";
import { concat, Subscribable, Subscription } from "rxjs";
import { registerLocaleData } from "@angular/common";
import { stat } from "fs";
import { timeStamp } from "console";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { concatMap, last } from "rxjs/operators";
import { GoogleAnalyticsService } from "src/app/google-analytics.service";

@Component({
  selector: "app-registration-form",
  templateUrl: "./registration-form.component.html",
  styleUrls: ["./registration-form.component.scss"],
})
export class RegistrationFormComponent implements OnInit {
  formGroup: FormGroup;
  blnShowFormRest: boolean = false;
  @ViewChild("container", { static: true, read: ViewContainerRef })
  entry: ViewContainerRef;
  @ViewChild("btnValidate", { static: false }) btnValidate: ElementRef;


  providerSelected: boolean = false;
  nurseSelected: boolean = false;
  otherSelected: boolean = false;
  newReg0: boolean = false;
  regNew: boolean = true;
  additionalAddress: boolean = false;
  providers: boolean = false;
  conMessage: boolean = false;
  addedPrescribers: boolean = false;
  statesLs: string[] = [];
  formCntr = 0;
  public typeOfField: FieldOption = FieldOption.DropdownState;
  public npiFieldState: FieldOption = FieldOption.Text;
  public didNpiLookup = false;
  dynamicComponentClass = PhysicianLocaleFormComponent;
  showFieldError = false;
  // Keep track of list of generated components for removal purposes
  components = [];
  isFindButton: boolean = true;
  screenHeight: number;
  screenWidth: number;
  txtWidthTop = 47;
  txtOfficeName = 48;
  txtEmail = 38;
  txtWidthCity = 35;
  txtWidthPhone = 15;
  prescriberPayload: any = {};
  allFacilities: Facility[] = [];
  cardHeader = "Practice";
  states: any[];
  chkIsPrimary: boolean = true;
  hashPrimary: { [indexer: string]: boolean } = {};
  removeMainCard: boolean = false;
  locaPath: any;
  blnHasCapital: boolean = false;
  blnHasOneNumber: boolean = false;
  blnHasSpecialChar: boolean = false;
  blnHasLength: boolean = false;
  blnPasswordBoxValid: boolean = false;
  blnPasswordsMatch: boolean = false;
  blnLowerCase: boolean = false;
  prevPasswordResults: any = null;
  submitted = false;
  isChecked: boolean = false;
  addRowProvider;
  isUserName: boolean = false;
  facAddCount: number = 2;
  onAddEditRecordId: number;
  provIdDelete: any;
  submitSubscription: Subscription;
  regAddress: any[] = [];
  Username;
  Password;
  PasswordConfirmation;
  MasterAccountId;
  MasterFacilityId;
  prescriberPkId;
  practiceAddress: any[] = [];
  isFirstNameError: boolean = false;
  isLastNameError: boolean = false;
  isPhoneError: boolean = false;
  isFaxError: boolean = false;
  isEmailError: boolean = false;

  organizationNPI;
  practiceName;
  organizatinTaxId;
  addressLine1;
  addressLine2;
  City;
  State;
  reqZip;
  contactFirstName;
  contactSecondName;
  reqPhone;
  reqFax;
  reqEmail;
  practiceGroup;
  addressforScreen: any[] = [];
  addressFromFirstScreen: any[] = [];
  addressFromSecondScreen: any[] = [];
  allProvidersMasterList: any[] = [];
  newProvidersWithFacilities: any[] = [];
  facilitiesCallData: any[] = [];
  recordIdToFacilityId: any = {};
  checkedFacilityCount: any[] = [];
  newFacilityCount: number = 1;
  facilityNPI;

  orgNpi;
  taxId;
  line1;
  line2;
  city;
  state;
  zip;
  firstName;
  secondtName;
  phone;
  fax;
  email;
  formResetGlobal;
  associatePhone;
  associateFax;
  associateEmail;
  isEditAssociateRow: boolean = false;

  // Provider registration screen
  providerNpi;
  providerNpiStore;
  providerFirstName;
  providerLastName;
  providerDisable: boolean = false;
  providerNpiError: boolean = false;
  lastName;
  userName;
  password;
  confirmPassword;
  providerNpiTable: any[] = [];
  addPracticeName;
  addPhone: string = "";
  addFax: string = "";
  addEmail: string = "";
  provAddress1: string = "";
  provAddress2: string = "";
  provCity;
  provState;
  provZip;
  //**************** */

  masterFacilityImportData: any[] = [];
  masterFacilityImportData1;

  address1;
  address2;
  cityReg;
  stateReg;
  zipReg;

  reqProviders: any[] = [];
  addedPrescriberList: any[] = [];
  hcpNPI;
  hcpFirstName;
  hcpLastName;
  taxIdReq;
  ptan;

  filterTableEnabled: boolean = false;
  registerButtonEnabled: boolean = false;
  public isOrgNPIExists: boolean = false;
  isLoading: boolean = false;
  rowActive;
  radioChecked: boolean = false;
  userSelected: string = "";
  allProvidersName: any = {};
  modalSubmitDisable: any = {};

  public contentURL;
  public page;
  public currentFileName: string = "";

  roleType = {
    Provider: 3,
    // Nurse: 4,
    Other: 4
  };

  isFacilityEditingEnable: boolean = false; //Editing Facility Row

  prescriberObj;
  type: string = "";
  isIncorrectNPI: boolean = false
  userContactId = null;

  // Registration screen apyload
  firstScreenPayload;
  secondScreenPayload;
  thirdScreenPayload;
  addressCollectionForProviders: any[] = [];
  masterFacilityIdSecondScreen;

  //Progress Nav
  progressStep1: boolean = true;
  progressStep2: boolean = false;
  progressStep3: boolean = false;
  progressStep4: boolean = false;
  
  newPasswordShowPasswordIcon: boolean = false;
  confirmPasswordShowPasswordIcon: boolean = false;
  searchFacilities: string = '';

  public staticStateList: any[] = [
    { name: "AL", abbreviation: "AL" },
    { name: "AK", abbreviation: "AK" },
    { name: "AR", abbreviation: "AR" },
    { name: "AS", abbreviation: "AS" },
    { name: "AZ", abbreviation: "AZ" },
    { name: "CA", abbreviation: "CA" },
    { name: "CO", abbreviation: "CO" },
    { name: "CT", abbreviation: "CT" },
    { name: "DE", abbreviation: "DE" },
    { name: "DC", abbreviation: "DC" },
    { name: "FM", abbreviation: "FM" },
    { name: "FL", abbreviation: "FL" },
    { name: "GA", abbreviation: "GA" },
    { name: "GU", abbreviation: "GU" },
    { name: "HI", abbreviation: "HI" },
    { name: "IA", abbreviation: "IA" },
    { name: "ID", abbreviation: "ID" },
    { name: "IL", abbreviation: "IL" },
    { name: "IN", abbreviation: "IN" },
    { name: "KS", abbreviation: "KS" },
    { name: "KY", abbreviation: "KY" },
    { name: "LA", abbreviation: "LA" },
    { name: "MA", abbreviation: "MA" },
    { name: "MD", abbreviation: "MD" },
    { name: "ME", abbreviation: "ME" },
    { name: "MH", abbreviation: "MH" },
    { name: "MI", abbreviation: "MI" },
    { name: "MN", abbreviation: "MN" },
    { name: "MO", abbreviation: "MO" },
    { name: "MP", abbreviation: "MP" },
    { name: "MS", abbreviation: "MS" },
    { name: "MT", abbreviation: "MT" },
    { name: "NC", abbreviation: "NC" },
    { name: "ND", abbreviation: "ND" },
    { name: "NE", abbreviation: "NE" },
    { name: "NH", abbreviation: "NH" },
    { name: "NJ", abbreviation: "NJ" },
    { name: "NM", abbreviation: "NM" },
    { name: "NV", abbreviation: "NV" },
    { name: "NY", abbreviation: "NY" },
    { name: "OH", abbreviation: "OH" },
    { name: "OK", abbreviation: "OK" },
    { name: "OR", abbreviation: "OR" },
    { name: "PA", abbreviation: "PA" },
    { name: "PR", abbreviation: "PR" },
    { name: "PW", abbreviation: "PW" },
    { name: "RI", abbreviation: "RI" },
    { name: "SC", abbreviation: "SC" },
    { name: "SD", abbreviation: "SD" },
    { name: "TN", abbreviation: "TN" },
    { name: "TX", abbreviation: "TX" },
    { name: "TT", abbreviation: "TT" },
    { name: "UT", abbreviation: "UT" },
    { name: "VA", abbreviation: "VA" },
    { name: "VI", abbreviation: "VI" },
    { name: "VT", abbreviation: "VT" },
    { name: "WA", abbreviation: "WA" },
    { name: "WI", abbreviation: "WI" },
    { name: "WV", abbreviation: "WV" },
    { name: "WY", abbreviation: "WY" },
  ];

  constructor(
    private fb: FormBuilder,
    private formData: SharedFormService,
    private sharedStateSvc: SharedStateService,
    private router: Router,
    private googleAnalytics: GoogleAnalyticsService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef
  ) {
    this.statesLs = this.formData.getStatesData();

    this.formData.confirmExit.subscribe((evt) => {
      if (evt) {
        delete this.allProvidersMasterList[this.provIdDelete];
        this.provIdDelete = null;
      }
    });
  }
  displayStyle = "none";

  openPopup() {
    this.displayStyle = "block";
  }
  closePopup(bodyText) {
    this.displayStyle = "none";
  }

  ngOnInit() {
    this.locaPath = window.location.hash;
    this.getScreenSize();
    if (
      this.sharedStateSvc.PrimaryState.prescriberInfo &&
      this.sharedStateSvc.PrimaryState.prescriberInfo.facilities.length > 0
    ) {
      this.loadStateForm();
      this.didNpiLookup = true;
      this.blnShowFormRest = true;
      this.cardHeader =
        this.cardHeader + " - " + this.formGroup.get("officeName0").value;
    } else {
      this.loadDefaultForm();
    }
  }

  @HostListener("window:resize", ["$event"])
  getScreenSize(event?) {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 1024) {
      this.txtWidthTop = 35;
      this.txtOfficeName = 32;
      this.txtWidthCity = 24;
      this.txtWidthPhone = 12;
      this.txtEmail = 30;
    } else if (this.screenWidth > 1024) {
      this.txtWidthTop = 47;
      this.txtOfficeName = 48;
      this.txtWidthCity = 35;
      this.txtWidthPhone = 15;
      this.txtEmail = 38;
    }
  }
  private loadStateForm(): void {
    const primaryFacility: Facility = this.sharedStateSvc.PrimaryState
      .prescriberInfo.facilities[0] as Facility;
    this.hashPrimary["emailAddress0"] = primaryFacility.Rank === 1;
    this.chkIsPrimary = primaryFacility.Rank === 1;

    this.formGroup = this.fb.group({
      prescriberFirstName0: [
        this.sharedStateSvc.PrimaryState.prescriberInfo.firstName,
        Validators.required,
      ],
      prescriberLastName0: [
        this.sharedStateSvc.PrimaryState.prescriberInfo.lastName,
        Validators.required,
      ],
      prescriberNPI0: [
        this.sharedStateSvc.PrimaryState.prescriberInfo.npi,
        Validators.required,
      ],
      practiceGroup0: [primaryFacility.PracticeGroup, Validators.required],
      taxid0: ["", Validators.required],
      officeName0: [primaryFacility.OfficeName, Validators.required],
      officeAddress10: [primaryFacility.Address.Line1, Validators.required],
      officeAddress20: [primaryFacility.Address.Line2],
      city0: [primaryFacility.Address.City, Validators.required],
      state0: [primaryFacility.Address.State, Validators.required],
      zip0: [
        primaryFacility.Address.Zipcode,
        [Validators.required, Validators.pattern(this.formData.zip)],
      ],
      phoneNumber0: [primaryFacility.Phone.Number, [Validators.required]],
      ext0: [primaryFacility.Phone.Extension, [Validators.minLength(2)]],
      fax0: [primaryFacility.Fax],
      emailAddress0: ["", [Validators.required, Validators.email]],
      username: ["", [Validators.required, Validators.email]],
      password: [
        this.sharedStateSvc.PrimaryState.prescriberInfo.pwd,
        Validators.required,
      ],
      confirmPassword: [
        this.sharedStateSvc.PrimaryState.prescriberInfo.confirmPwd,
        Validators.required,
      ],
    });
    this.allFacilities.push(primaryFacility);
    let iter = 1;
    while (
      iter < this.sharedStateSvc.PrimaryState.prescriberInfo.facilities.length
    ) {
      const fac = this.sharedStateSvc.PrimaryState.prescriberInfo.facilities[
        iter
      ] as Facility;
      this.addLocaleComponent(fac);
      this.allFacilities.push(fac);
      iter++;
    }
  }
  private loadDefaultForm(): void {
    this.hashPrimary["emailAddress0"] = true;
    this.chkIsPrimary = true;
    this.formGroup = this.fb.group({
      prescriberFirstName0: [null, Validators.required],
      prescriberLastName0: [null, Validators.required],
      prescriberNPI0: [null, Validators.required],
      practiceGroup0: [null, Validators.required],
      taxid0: [null, Validators.required],
      officeName0: [null, Validators.required],
      officeAddress10: [null, Validators.required],
      officeAddress20: [null],
      city0: [null, Validators.required],
      state0: [null, Validators.required],
      zip0: [
        null,
        [Validators.required, Validators.pattern(this.formData.zip)],
      ],
      phoneNumber0: [null, [Validators.required]],
      ext0: [null, [Validators.minLength(2)]],
      fax0: [null, Validators.required],
      emailAddress0: ["", [Validators.required, Validators.email]],
      username: ["", [Validators.required, Validators.email]],
      password: [null, Validators.required],
      confirmPassword: [null, Validators.required],
    });
  }

  showNext(): void {
    this.submitted = true;
    if (
      this.formGroup.get("prescriberFirstName0").valid &&
      this.formGroup.get("prescriberLastName0").valid &&
      this.formGroup.get("prescriberNPI0").valid
    ) {
      this.formData.hideLoader.next(true);
      const buildUrl =
        this.formGroup.controls.prescriberNPI0.value +
        "/" +
        this.formGroup.controls.prescriberFirstName0.value +
        "/" +
        this.formGroup.controls.prescriberLastName0.value;
      this.sharedStateSvc.PrimaryState.prescriberInfo.firstName =
        this.formGroup.controls.prescriberFirstName0.value;
      this.sharedStateSvc.PrimaryState.prescriberInfo.lastName =
        this.formGroup.controls.prescriberLastName0.value;
      this.sharedStateSvc.PrimaryState.prescriberInfo.npi =
        this.formGroup.controls.prescriberNPI0.value;

      this.sharedStateSvc
        .validatePrescriber(buildUrl)
        .then((resp) => {
          this.sharedStateSvc.PrimaryState.prescriberInfo.data = resp.Payload[0]
            ? resp.Payload[0]
            : "";
          this.prescriberPayload = resp.Payload[0] ? resp.Payload[0] : "";
          this.loadFacilities(resp.Payload[0]);
          this.cardHeader = this.formGroup.get("officeName0").value
            ? this.cardHeader + " - " + this.formGroup.get("officeName0").value
            : this.cardHeader;
          this.blnShowFormRest = true;
          this.didNpiLookup = true;
          this.showFieldError = false;
          this.formData.hideLoader.next(false);
          this.submitForm();
        })
        .catch((err) => {
          this.showFieldError = true;
          this.didNpiLookup = false;
          this.formData.hideLoader.next(false);
          this.toastr.error("There was a service error!");
        });
    }
  }
  loadFacilities(payload: any): void {
    if (payload.Facilities && payload.Facilities.length) {
      this.formGroup.get("practiceGroup0").setValue(payload.Facilities[0].Name);
      this.formGroup.get("officeName0").setValue(payload.Facilities[0].Name);
      this.formGroup
        .get("officeAddress10")
        .setValue(payload.Facilities[0].Address1);
      this.formGroup
        .get("officeAddress20")
        .setValue(payload.Facilities[0].Address2);
      this.formGroup.get("city0").setValue(payload.Facilities[0].City);
      this.formGroup.get("state0").setValue(payload.Facilities[0].State);
      this.formGroup.get("zip0").setValue(payload.Facilities[0].Zip);
      let iter = 0;
      while (iter < payload.Facilities.length) {
        const fac = new Facility();
        fac.PracticeGroup = payload.Facilities[iter].Name;
        fac.OfficeName = payload.Facilities[iter].Name;
        fac.Address = new Address();
        fac.Address.Line1 = payload.Facilities[iter].Address1;
        fac.Address.Line2 = payload.Facilities[iter].Address2;
        fac.Address.State = payload.Facilities[iter].State;
        fac.Address.City = payload.Facilities[iter].City;
        fac.Address.Zipcode = payload.Facilities[iter].Zip;
        fac.ServiceId = payload.Facilities[iter].Id;
        fac.FacilityId = iter;
        fac.Phone = new Phone();

        if (iter > 0) {
          this.addLocaleComponent(fac);
        }

        this.allFacilities.push(fac);

        iter++;
      }
    } else {
      const fac = new Facility();
      fac.PracticeGroup = null;
      fac.OfficeName = null;
      fac.Address = new Address();
      fac.Address.Line1 = null;
      fac.Address.Line2 = null;
      fac.Address.State = null;
      fac.Address.City = null;
      fac.Address.Zipcode = null;
      fac.ServiceId = null;
      fac.FacilityId = 0;
      fac.Phone = new Phone();
      this.allFacilities.push(fac);
    }
  }
  validateNextNpi(): boolean {
    return !(
      this.formGroup.get("prescriberFirstName").touched &&
      this.formGroup.get("prescriberFirstName").valid &&
      this.formGroup.get("prescriberLastName").touched &&
      this.formGroup.get("prescriberLastName").valid &&
      this.formGroup.get("prescriberNPI").touched &&
      this.formGroup.get("prescriberNPI").valid
    );
  }
  removeLocaleComponent(componentClass: Type<any>): void {
    if (this.formCntr === 0) {
      return;
    }

    const component = this.components.find(
      (component) => component.instance instanceof componentClass
    );
    const componentIndex = this.components.indexOf(component);

    if (componentIndex !== -1) {
      // Remove component from both view and array
      this.entry.remove(this.entry.indexOf(component));
      this.components.splice(componentIndex, 1);
      this.formCntr--;
    }
  }
  private removeControls(currPos: number): void {
    this.formGroup.removeControl("practiceGroup" + currPos);
    this.formGroup.removeControl("officeName" + currPos);
    this.formGroup.removeControl("officeAddress1" + currPos);
    this.formGroup.removeControl("officeAddress2" + currPos);
    this.formGroup.removeControl("city" + currPos);
    this.formGroup.removeControl("state" + currPos);

    this.formGroup.removeControl("zip" + currPos);
    this.formGroup.removeControl("phoneNumber" + currPos);
    this.formGroup.removeControl("ext" + currPos);
    this.formGroup.removeControl("fax" + currPos);
    this.formGroup.removeControl("emailAddress" + currPos);
  }
  addLocaleComponent(facilityValues?: Facility): void {
    const patterns = {
      email: this.formData.email,
      phone: this.formData.phone,
      zip: this.formData.zip,
    };
    if (!facilityValues) {
      facilityValues = {};
      facilityValues.Address = {};
      facilityValues.Phone = {};
    }
    const dynamicForm = {};
    dynamicForm["practiceGroup" + facilityValues.FacilityId] = this.fb.control(
      facilityValues.PracticeGroup ? facilityValues.PracticeGroup : null,
      Validators.required
    );
    dynamicForm["officeName" + facilityValues.FacilityId] = this.fb.control(
      facilityValues.OfficeName ? facilityValues.OfficeName : null,
      Validators.required
    );
    dynamicForm["officeAddress1" + facilityValues.FacilityId] = this.fb.control(
      facilityValues.Address.Line1 ? facilityValues.Address.Line1 : null,
      Validators.required
    );
    dynamicForm["officeAddress2" + facilityValues.FacilityId] = this.fb.control(
      facilityValues.Address.Line2 ? facilityValues.Address.Line2 : null
    );
    dynamicForm["city" + facilityValues.FacilityId] = this.fb.control(
      facilityValues.Address.City ? facilityValues.Address.City : null,
      Validators.required
    );
    dynamicForm["state" + facilityValues.FacilityId] = this.fb.control(
      facilityValues.Address.State ? facilityValues.Address.State : "AL",
      Validators.required
    );
    dynamicForm["zip" + facilityValues.FacilityId] = this.fb.control(
      facilityValues.Address.Zipcode ? facilityValues.Address.Zipcode : null,
      [Validators.required, Validators.pattern(this.formData.zip)]
    );
    dynamicForm["phoneNumber" + facilityValues.FacilityId] = this.fb.control(
      facilityValues.Phone.Number ? facilityValues.Phone.Number : null,
      [Validators.required]
    );
    dynamicForm["ext" + facilityValues.FacilityId] = this.fb.control(
      facilityValues.Phone.Extension ? facilityValues.Phone.Extension : null,
      [Validators.minLength(2)]
    );
    dynamicForm["fax" + facilityValues.FacilityId] = this.fb.control(
      facilityValues.Fax ? facilityValues.Fax : null
    );
    dynamicForm["emailAddress" + facilityValues.FacilityId] = this.fb.control(
      facilityValues.Email ? facilityValues.Email : null
    );

    this.formData.addToFormGroup(this.formGroup, dynamicForm);
    facilityValues.DynamicForm = dynamicForm;
  }
  checkIfCanSubmit(): boolean {
    return !this.formGroup.valid;
  }
  loadMainFacility(): Facility {
    const svcId =
      this.prescriberPayload.Facilities &&
        this.prescriberPayload.Facilities[0].Id
        ? this.prescriberPayload.Facilities[0].Id
        : this.sharedStateSvc.PrimaryState.prescriberInfo.facilities[0]
          .ServiceId
          ? this.sharedStateSvc.PrimaryState.prescriberInfo.facilities[0]
            .ServiceId
          : null;
    const facility: Facility = new Facility();
    facility.FacilityId = 0;
    facility.ServiceId = svcId;
    facility.PracticeGroup = this.formGroup.get("practiceGroup").value;
    facility.Email = this.formGroup.get("emailAddress").value;
    facility.Fax = this.formGroup.get("fax").value;
    facility.OfficeName = this.formGroup.get("officeName").value;
    facility.Rank = 1;
    facility.Address = new Address();
    facility.Address.City = this.formGroup.get("city").value;
    facility.Address.Line1 = this.formGroup.get("officeAddress1").value;
    facility.Address.Line2 = this.formGroup.get("officeAddress2").value;
    facility.Address.State = this.formGroup.get("state").value;
    facility.Address.Zipcode = this.formGroup.get("zip").value;
    facility.Phone = new Phone();
    facility.Phone.Number = this.formGroup.get("phoneNumber").value;
    facility.Phone.Extension = this.formGroup.get("ext").value;
    facility.ContactAdded = 1;
    facility.Contacts = [];
    return facility;
  }
  checkFormValidity(): boolean {
    let invalidCntr = 0;
    let formValid = true;
    Object.keys(this.formGroup.controls).forEach((key) => {
      if (!this.formGroup.controls[key].valid) {
        if (!(key in this.hashPrimary)) {
          invalidCntr++;
        }
      }
    });
    if (invalidCntr > 0) {
      formValid = false;
    }
    let primaryCounter = 0;
    for (const key in this.hashPrimary) {
      if (this.hashPrimary.hasOwnProperty(key)) {
        if (this.hashPrimary[key] && this.formGroup.controls[key].value) {
          primaryCounter++;
        }
      }
    }
    if (primaryCounter > 1) {
      this.toastr.error("You have more than one primary office!");
      formValid = false;
    } else if (primaryCounter === 0) {
      this.toastr.error(
        "You need to have a primary facility with a valid email!"
      );
      formValid = false;
    }

    return formValid;
  }

  private cleanPhone(phone: Phone): Phone {
    if (!phone) {
      return phone;
    }
    const p = new Phone();
    p.Number = phone.Number.replace(/\D/g, "");
    p.Extension = phone.Extension;
    return p;
  }
  private refactorContacts(contacts: Contact[]): any[] {
    const contactsPayload = [];
    contacts.forEach((contact) => {
      const phone = this.cleanPhone(contact.Phone);
      contactsPayload.push({
        Id: +contact.OfficeContactId,
        OfficeContactType: contact.OfficeContactType,
        FirstName: contact.FirstName,
        LastName: contact.LastName,
        Email: contact.Email ? contact.Email : null,
        Title: contact.Title,
        Rank: contact.Rank,
        Fax: contact.Fax ? contact.Fax.replace(/\D/g, "") : null,
        Phone: phone.Number,
        Extension: phone.Extension,
      });
    });
    return contactsPayload;
  }
  private refactorFacility(facilities: Facility[]): any[] {
    const facilityPayload = [];
    const notRanked = facilities.filter((f) => f.Rank === 0);
    notRanked.forEach((fac, i) => {
      fac.Rank = i + 2;
    });
    facilities.forEach((fac, i) => {
      const phone = this.cleanPhone(fac.Phone);
      facilityPayload.push({
        PracticeGroup: fac.PracticeGroup,
        OfficeName: fac.OfficeName,
        Address: fac.Address,
        Fax: fac.Fax ? fac.Fax.replace(/\D/g, "") : null,
        Phone: phone.Number,
        Extension: phone.Extension,
        Email: fac.Email,
        Rank: fac.Rank,
        Id: fac.ServiceId ? fac.ServiceId : null,
        Contacts: this.refactorContacts(fac.Contacts),
      });
    });
    return facilityPayload;
  }
  submitForm(): void {
    this.submitted = true;
    if (
      this.formGroup.get("prescriberFirstName0").valid &&
      this.formGroup.get("prescriberLastName0").valid &&
      this.formGroup.get("prescriberNPI0").valid
    ) {
      this.formData.hideLoader.next(true);
      const buildUrl =
        this.formGroup.controls.prescriberNPI0.value +
        "/" +
        this.formGroup.controls.prescriberFirstName0.value +
        "/" +
        this.formGroup.controls.prescriberLastName0.value;
      this.sharedStateSvc.PrimaryState.prescriberInfo.firstName =
        this.formGroup.controls.prescriberFirstName0.value;
      this.sharedStateSvc.PrimaryState.prescriberInfo.lastName =
        this.formGroup.controls.prescriberLastName0.value;
      this.sharedStateSvc.PrimaryState.prescriberInfo.npi =
        this.formGroup.controls.prescriberNPI0.value;

      this.sharedStateSvc
        .validatePrescriber(buildUrl)
        .then((resp) => {
          this.sharedStateSvc.PrimaryState.prescriberInfo.data = resp.Payload[0]
            ? resp.Payload[0]
            : "";
          this.prescriberPayload = resp.Payload[0] ? resp.Payload[0] : "";
          this.loadFacilities(resp.Payload[0]);
          this.cardHeader = this.formGroup.get("officeName0").value
            ? this.cardHeader + " - " + this.formGroup.get("officeName0").value
            : this.cardHeader;
          this.blnShowFormRest = true;
          this.didNpiLookup = true;
          this.showFieldError = false;
          this.formData.hideLoader.next(false);
        })
        .catch((err) => {
          this.showFieldError = true;
          this.didNpiLookup = false;
          this.formData.hideLoader.next(false);
          this.toastr.error("There was a service error!");
        });
    }
    if (this.checkFormValidity()) {
      let primeEmail = "";

      for (const key in this.hashPrimary) {
        if (this.hashPrimary.hasOwnProperty(key)) {
          if (this.hashPrimary[key]) {
            primeEmail = this.formGroup.get(key).value;
            break;
          }
        }
      }
      let rankType = 1;

      this.sharedStateSvc.PrimaryState.prescriberInfo.facilities = [];
      this.formData.hideLoader.next(true);
      // this.sharedStateSvc
      //   .checkIfEmailUsed(primeEmail)
      //   .then((resp) => {
      //     this.formData.hideLoader.next(false);
      //     if (resp.Payload) {
      //       const facility: Facility = new Facility();
      //       facility.PracticeGroup = this.formGroup.value.practiceGroup0;
      //       facility.Email = this.formGroup.value.emailAddress0;
      //       facility.Fax = this.formGroup.value.fax0.replace(/\D+/g, "");
      //       facility.OfficeName = this.formGroup.value.officeName0;
      //       facility.Rank = rankType;
      //       facility.Address = new Address();
      //       facility.Address.City = this.formGroup.value.city0;
      //       facility.Address.Line1 = this.formGroup.value.officeAddress10;
      //       facility.Address.Line2 = this.formGroup.value.officeAddress20;
      //       facility.Address.State = this.formGroup.value.state0;
      //       facility.Address.Zipcode = this.formGroup.value.zip0;
      //       facility.Phone = this.formGroup.value.phoneNumber0.replace(
      //         /\D+/g,
      //         ""
      //       );
      //       facility.Contacts = [
      //         {
      //           Email: facility.Email,
      //           Fax: facility.Fax,
      //           FirstName: this.formGroup.value.prescriberFirstName0,
      //           LastName: this.formGroup.value.prescriberLastName0,
      //           OfficeContactType: "Office Contact",
      //           Rank: facility.Rank,
      //           Title: "RN",
      //           Phone: facility.Phone,
      //         },
      //       ];

      //       this.sharedStateSvc.PrimaryState.prescriberInfo.facilities.push(
      //         facility
      //       );

      //       rankType = 0;
      //       const facilities =
      //         this.sharedStateSvc.PrimaryState.prescriberInfo.facilities;

      //       this.sharedStateSvc.PrimaryState.prescriberInfo.pwd =
      //         this.formGroup.get("password").value;
      //       this.sharedStateSvc.PrimaryState.prescriberInfo.confirmPwd =
      //         this.formGroup.get("confirmPassword").value;
      //       const finalFormPayLoad = {
      //         Username: this.formGroup.value.username,
      //         Password: this.formGroup.get("password").value,
      //         PasswordConfirmation: this.formGroup.get("confirmPassword").value,
      //         PrescriberId: 1000149281,
      //         Facilities: facilities,
      //       };

      //       this.formData.hideLoader.next(true);
      //       this.submitSubscription = this.sharedStateSvc
      //         .registerAccount(finalFormPayLoad)
      //         .subscribe(
      //           (res) => {
      //             this.formData.hideLoader.next(false);
      //             this.router.navigate(["/registration/complete"]);
      //           },
      //           (err) => {
      //             this.formData.hideLoader.next(false);
      //             this.toastr.error("There was an error in registration!");
      //           }
      //         );

      //       this.router.navigate(["/registration/complete"]);
      //     } else {
      //       this.toastr.error(
      //         "The email: " + primeEmail + " is already in use."
      //       );
      //     }
      //   })
      //   .catch((err) => {
      //     this.formData.hideLoader.next(false);
      //     this.toastr.error("There was an error in checking email");
      //   });
    } else {
      Object.keys(this.formGroup.controls).forEach((key) => {
        if (!this.formGroup.controls[key].valid) {
          if (key.indexOf("emailAddress") < 0) {
            this.formData.formStatusEvent.next(key);
          }
        }
      });
      for (const key in this.hashPrimary) {
        if (this.hashPrimary.hasOwnProperty(key)) {
          if (this.hashPrimary[key] && !this.formGroup.controls[key].value) {
            this.formData.formStatusEvent.next(key);
            break;
          }
        }
      }
      window.scrollTo(0, 0);
    }
  }
  addNewLocale(event): void {
    const newFac = new Facility();
    newFac.Address = new Address();
    newFac.Phone = new Phone();
    const indx = this.allFacilities.findIndex(
      (f) => f && f.FacilityId === event
    );
    const maxId = Math.max.apply(
      Math,
      this.allFacilities
        .filter((f) => f)
        .map(function (o) {
          return o.FacilityId;
        })
    );
    newFac.FacilityId = maxId + 1;
    this.addLocaleComponent(newFac);
    this.allFacilities.splice(indx + 1, 0, newFac);
  }
  removeNewLocale(event): void {

    this.removeControls(event);

    const indx = this.allFacilities.findIndex(
      (f) => f && f.FacilityId === event
    );
    if (indx === 0) {
      this.removeMainCard = true;
      this.allFacilities.splice(indx, 1);
      this.allFacilities.splice(indx, 0, null);
    } else {
      this.allFacilities.splice(indx, 1);
    }
  }
  checkPrimary(): void {
    if (this.chkIsPrimary) {
      this.hashPrimary["emailAddress0"] = true;
    } else {
      this.hashPrimary["emailAddress0"] = false;
    }
  }
  setPrimaryVal(key): void {
    this.hashPrimary[key] = true;
    let primaryCounter = 0;
    for (const key in this.hashPrimary) {
      if (this.hashPrimary.hasOwnProperty(key)) {
        if (this.hashPrimary[key]) {
          primaryCounter++;
        }
      }
    }
    if (primaryCounter > 1) {
      this.toastr.error("You have more than one primary office!");
    }
  }
  unSetPrimaryVal(key): void {
    this.hashPrimary[key] = false;
  }
  nextFocus(event): void {
    if (event) {
      this.btnValidate.nativeElement.focus();
    }
  }

  passwordValidation(isFirstPassword, value): Function {
    return (checkValue) => {
      const specialCharCheck = /[ `!@#$%^&*]/;
      const capitalCheck = /[A-Z]+/;
      const lengthCheck = checkValue.length > 7 && checkValue.length < 31;
      const oneNumber = /.*[0-9].*/;
      const lowerCaseCheck = /[a-z]+/;
      return {
        hasSpecial: specialCharCheck.test(checkValue),
        hasCapital: capitalCheck.test(checkValue),
        hasLength: lengthCheck,
        hasOneNumber: oneNumber.test(checkValue),
        hasPasswordMatch: false,
        hasLowerCase: lowerCaseCheck.test(checkValue),
        currentValue: checkValue,
        firstPasswordField: isFirstPassword,
        verbiage: " Does not meet requirements",
      };
    };
  }
  checkpassword(event) {
    const specialCharCheck = /[ `!@#$%^&*]/;
    const capitalCheck = /[A-Z]+/;
    const lengthCheck = event && event.length > 7 && event.length < 31;
    const oneNumber = /.*[0-9].*/;
    const lowerCaseCheck = /[a-z]+/;

    this.blnHasCapital = capitalCheck.test(event);
    this.blnHasLength = lengthCheck;
    this.blnHasOneNumber = oneNumber.test(event);
    this.blnHasSpecialChar = specialCharCheck.test(event);
    this.blnLowerCase = lowerCaseCheck.test(event);
  }
  updateValidationBox(eventVal): void {
    this.blnHasCapital = eventVal.hasCapital;
    this.blnHasLength = eventVal.hasLength;
    this.blnHasOneNumber = eventVal.hasOneNumber;
    this.blnHasSpecialChar = eventVal.hasSpecial;
    this.blnPasswordsMatch = eventVal.hasPasswordMatch;
    this.blnLowerCase = eventVal.hasLowerCase;
    this.blnPasswordBoxValid = (this.blnHasCapital && this.blnHasLength && this.blnHasOneNumber && this.blnHasSpecialChar && this.blnPasswordsMatch && this.blnLowerCase);
    this.prevPasswordResults = eventVal;
  }
  confirmPasswords(isFirstPassword): Function {
    return (checkValue) => {
      if (this.prevPasswordResults && !isFirstPassword) {
        this.prevPasswordResults = {
          ...this.prevPasswordResults,
          firstPasswordField: isFirstPassword,
          verbiage: "Passwords do not match",
          hasPasswordMatch:
            checkValue === this.prevPasswordResults.currentValue,
        };
      }
      return this.prevPasswordResults;
    };
  }
  passKey: boolean = false;
  onKeyUpEvent(event) {
    this.passKey = true;
  }

  addressFormatter(addressObj) {
    let array = [addressObj.Address1, addressObj.Address2, addressObj.City, addressObj.State, addressObj.Zip || addressObj.Address.Zipcode];
    return array.filter(Boolean).join(",");
  }

  resetProviderDetails() {
    this.isFindButton = true;
    this.firstName = "";
    this.lastName = "";
    this.email = "";
    this.phone = "";
    this.fax = "";
    this.providerFirstName = "";
    this.providerLastName = "";
    this.providerNpi = "";
    this.providerDisable = false;
    this.isFirstNameError = false;
    this.isLastNameError = false;
    this.isPhoneError = false;
    this.isFaxError = false;
    this.isEmailError = false;
  }

  resetPage() {
    this.isFindButton = true;
    this.submitted = false;
    this.isChecked = false;
    this.isFindButton = true;

    this.isUserName = false;
    this.facAddCount = 2;

    this.regAddress = [];
    this.Username = "";
    this.Password = "";
    this.PasswordConfirmation = "";
    this.MasterAccountId = "";
    this.MasterFacilityId = "";
    this.prescriberPkId = "";
    this.practiceAddress = [];

    this.organizationNPI = "";
    this.practiceName = "";
    this.organizatinTaxId = "";
    this.addressLine1 = "";
    this.addressLine2 = "";
    this.City = "";
    this.State = "";
    this.reqZip = "";
    this.contactFirstName = "";
    this.contactSecondName = "";
    this.reqPhone = "";
    this.reqFax = "";
    this.reqEmail = "";
    this.practiceGroup = "";

    this.addressforScreen = [];
    this.addressFromFirstScreen = [];
    this.addressFromSecondScreen = [];
    this.allProvidersMasterList = [];
    this.facilityNPI = "";

    this.orgNpi = "";
    this.taxId = "";
    this.line1 = "";
    this.line2 = "";
    this.city = "";
    this.state = "";
    this.zip = "";
    this.firstName = "";
    this.secondtName = "";
    this.phone = "";
    this.fax = "";
    this.email = "";
    this.formResetGlobal = "";
    this.associatePhone = "";
    this.associateFax = "";
    this.associateEmail = "";
    this.isEditAssociateRow = false;

    // Provider registration screen
    this.providerNpi = "";
    this.providerNpiStore = "";
    this.providerFirstName = "";
    this.providerLastName = "";
    this.providerDisable = false;
    this.providerNpiError = false;
    this.lastName = "";
    this.userName = "";
    this.password = "";
    this.confirmPassword = "";
    this.providerNpiTable = [];
    this.addPracticeName = "";
    this.addPhone = "";
    this.addFax = "";
    this.addEmail = "";
    this.provAddress1 = "";
    this.provAddress2 = "";
    this.provCity = "";
    this.provState = "";
    this.provZip = "";
    //**************** */

    this.masterFacilityImportData = [];
    this.masterFacilityImportData1 = [];

    this.address1 = "";
    this.address2 = "";
    this.cityReg = "";
    this.stateReg = "";
    this.zipReg = "";

    this.hcpNPI = "";
    this.hcpFirstName = "";
    this.hcpLastName = "";
    this.taxIdReq = "";
    this.ptan = "";

    this.filterTableEnabled = false;
    this.registerButtonEnabled = false;

    this.type = "";
    this.userContactId = null;
    this.isFacilityEditingEnable = false;

    // Registration screen apyload
    this.firstScreenPayload = {};
    this.secondScreenPayload = {};
    this.thirdScreenPayload = {};
    this.masterFacilityIdSecondScreen = [];
    this.onAddEditRecordId = null;
    this.isIncorrectNPI = false;
  }

  providerDeleteHandler(event, key) {
    event.stopPropagation()
    this.provIdDelete = key
  }

  closeConFirmationPopUP(event) {
    this.provIdDelete = null
  }

  profileHandler(type) {
    this.resetPage();
    if (this.userSelected != type) {
      this.userSelected = type;
    }
    if (type == 'Provider')
      this.SendChoosePrescriberEvent();
    else if (type == 'Nurse')
      this.SendChooseHealthcareProfessionalEvent();
    else if (type == 'Other')
      this.SendChooseOthersEvent();
  }

  onSubmit0(form) {
    this.regNew = true;
    this.newReg0 = false;

    this.progressStep1 = true;
    this.progressStep2 = true;
    this.progressStep3 = false;
    this.progressStep4 = false;
  }

  // Here new registration Logic ************* for HCP Supernus Portal
  // Screen first Registration Logic ***********************

  // Add Provider NPI from API call
  addProviderNPIData(e) {
    this.isFirstNameError = false;
    this.isLastNameError = false;
    this.isPhoneError = false;
    this.isFaxError = false;
    this.isEmailError = false;
    e.preventDefault();
    this.reqProviders = [];
    this.providerNpiError = false;
    this.formData.hideLoader.next(true);

    this.sharedStateSvc
      .getProvidersDetails(
        this.providerNpi,
        this.providerFirstName,
        this.providerLastName
      )
      .subscribe(
        (res) => {
          if (res && res.Status === "SUCCESS" && res.Payload[0]) {
            this.providerDisable = true;
            this.firstName = res.Payload[0].PrescriberFirstName;
            this.lastName = res.Payload[0].PrescriberLastName;
            this.phone = "";
            this.fax = "";
            this.providerFirstName = this.firstName;
            this.providerLastName = this.lastName;
            this.isFindButton = false;
            this.email = "";
            this.prescriberObj = res.Payload[0]
            this.isFindButton = false

            this.providerNpiTable = [
              {
                npi: res.Payload[0].NPI,
                firstName: res.Payload[0].PrescriberFirstName,
                lastName: res.Payload[0].PrescriberLastName,
              },
            ];
            this.formData.hideLoader.next(false);
          }
        },
        (error) => {
          if (window.screen.width <= 480) {
            this.toastr.error(`One or more pieces of information entered do not match our records. Please try again or contact us for additional assistance.`);
          }
          this.formData.hideLoader.next(false);
          this.providerNpiError = true;
          // this.providerFirstName = "";
          // this.providerLastName = "";
          // this.providerNpi = "";
        }
      );

    this.providerNpiStore = this.providerNpi;
  }

  // Delete NPI entry on Provider registration first screen
  deleteNPI(item) {
    this.providerNpiTable.splice(this.providerNpiTable.indexOf(item), 1);
    this.providerDisable = false;
    this.firstName = "";
    this.lastName = "";
    this.phone = "";
    this.fax = "";
    this.email = "";
  }

  onSubmitProviderPage1(form) {
    this.progressStep1 = true;
    this.progressStep2 = true;
    this.progressStep3 = true;
    this.progressStep4 = false;
    this.addressFromFirstScreen = [];
    this.regNew = false;
    this.additionalAddress = true;
    this.providers = false;
    this.conMessage = false;

    // Final Form data
    this.firstScreenPayload = {
      Username: this.userName,
      EmailAddress: this.email,
      Password: this.password,
      PasswordConfirmation: this.confirmPassword,
      PrescriberId: this.prescriberObj.Id,
      IsNewUser: true,
      Role: {
        // RolePkId: this.roleType[this.userSelected],
        RolePkId: 4,
      },
      UserContactDetails: [
        {
          Email: this.email,
          FirstName: this.firstName,
          LastName: this.lastName,
          Phone: this.phone ? this.phone.replace(/\D+/g, "") : this.phone,
          Fax: this.fax ? this.fax.replace(/\D+/g, "") : this.fax
        }
      ]
    };
    this.regNew = false;
    this.additionalAddress = true;
    this.providers = false;
    this.conMessage = false;
    this.progressStep1 = true;
    this.progressStep2 = true;
    this.progressStep3 = true;
    this.progressStep4 = false;
  }

  // Add address on second screen of provider registration
  addAddressOnProvider() {
    const addressObject = {
      PracticeName: this.addPracticeName,
      Address: `${this.provAddress1}, ${this.provAddress2 ? this.provAddress2 + ", " : ""
        }${this.provCity}, ${this.provState}, Zip-${this.provZip} `,
      City: this.provCity,
      State: this.provState,
      Zip: this.provZip,
    };
    const addressObjectProviders = {
      PracticeName: this.addPracticeName,
      Address1: this.provAddress1,
      Address2: this.provAddress2,
      Address: `${this.provAddress1}, ${this.provAddress2 ? this.provAddress2 + ", " : ""
        }${this.provCity}, ${this.provState}, Zip-${this.provZip} `,
      City: this.provCity,
      State: this.provState,
      Zip: this.provZip,
      Phone: this.addPhone,
      Fax: this.addFax,
      Email: this.addEmail,
      Name: "Default",
      Id: this.masterFacilityIdSecondScreen,
      isSelected: true,
      recordId: this.facAddCount,
      GroupName: "Default",
      isEdit: false,
    };
  
    this.addressFromSecondScreen.push(addressObjectProviders);
    this.facAddCount++;
    this.provAddress1 = "";
    this.provAddress2 = "";
    this.provCity = "";
    this.provState = "";
    this.provZip = "";
    this.addPracticeName = "";
    this.addPhone = "";
    this.addFax = "";
    this.addEmail = "";
  }

  editAddressOnProvider(rowData) {
    this.provAddress1 = rowData.Address1;
    this.provAddress2 = rowData.Address2;
    this.provCity = rowData.City;
    this.provState = rowData.State;
    this.provZip = rowData.Zip;
    this.addPracticeName = rowData.PracticeName;
    this.addPhone = rowData.Phone;
    this.addFax = rowData.Fax;
    this.addEmail = rowData.Email;
    this.onAddEditRecordId = rowData.recordId;

    this.addressFromSecondScreen.forEach((item) => (item.isEdit = false));
    let index = this.addressFromSecondScreen.findIndex(
      (item) => item.recordId === rowData.recordId
    );
    if (index != -1) {
      this.addressFromSecondScreen[index].isEdit = true;
      this.isFacilityEditingEnable = true;
    }
  }

  editAddressUpdateOnProvider() {
    let postion = this.addressFromSecondScreen.findIndex(
      (item) => item.recordId === this.onAddEditRecordId
    );

    if (postion >= 0) {
      this.addressFromSecondScreen[postion].Address1 = this.provAddress1;
      this.addressFromSecondScreen[postion].Address2 = this.provAddress2;
      this.addressFromSecondScreen[postion].City = this.provCity;
      this.addressFromSecondScreen[postion].State = this.provState;
      this.addressFromSecondScreen[postion].Zip = this.provZip;
      this.addressFromSecondScreen[postion].PracticeName = this.addPracticeName;
      this.addressFromSecondScreen[postion].Phone = this.addPhone;
      this.addressFromSecondScreen[postion].Fax = this.addFax;
      this.addressFromSecondScreen[postion].Email = this.addEmail;
      (this.addressFromSecondScreen[postion].Address = `${this.provAddress1}, ${this.provAddress2 ? this.provAddress2 + ", " : ""
        }${this.provCity}, ${this.provState}, Zip-${this.provZip} `),
        (this.addressFromSecondScreen[postion].isEdit = false);
    }

    this.isFacilityEditingEnable = false

    this.onAddEditRecordId = null;
    this.provAddress1 = "";
    this.provAddress2 = "";
    this.provCity = "";
    this.provState = "";
    this.provZip = "";
    this.addPracticeName = "";
    this.addPhone = "";
    this.addFax = "";
    this.addEmail = "";
  }

  cancelAddressUpdateOnProvider() {
    let postion = this.addressFromSecondScreen.findIndex(
      (item) => item.recordId === this.onAddEditRecordId
    );

    if (postion >= 0) {
      this.addressFromSecondScreen[postion].isEdit = false;
    }

    this.isFacilityEditingEnable = false;

    this.onAddEditRecordId = null;
    this.provAddress1 = "";
    this.provAddress2 = "";
    this.provCity = "";
    this.provState = "";
    this.provZip = "";
    this.addPracticeName = "";
    this.addPhone = "";
    this.addFax = "";
    this.addEmail = "";
  }

  deleteAddressOnProvider(rowData) {
    let postion = this.addressFromSecondScreen.indexOf(rowData);
    this.addressFromSecondScreen.splice(postion, 1);
  }

  addDefaultFacilitiesOnProvider(formData) {
    this.progressStep1 = true;
    this.progressStep2 = true;
    this.progressStep3 = true;
    this.registrationDoneForProvider()
  }

  registrationDoneForProvider() {
    this.formData.hideLoader.next(true);

    // First API Call
    this.sharedStateSvc
      .userRegistration(this.firstScreenPayload)
      .subscribe((firstRes) => {
        if (firstRes && firstRes.Status === "SUCCESS") {
          this.MasterAccountId = firstRes.Payload.masterPortalAccountId; // Resonse Master Portal Account Id
          this.MasterFacilityId = firstRes.Payload.facilityId;
          this.userContactId = firstRes.Payload.contactId

          let keysList = Object.keys(this.allProvidersMasterList);

          for (let provId of keysList) {
            for (
              let j = 0;
              j < this.allProvidersMasterList[provId].length;
              j++
            ) {
              if (
                this.allProvidersMasterList[provId][j] &&
                this.allProvidersMasterList[provId][j].recordId
              ) {
                if (this.allProvidersMasterList[provId][j].recordId === 1) {
                  this.allProvidersMasterList[provId][j].Id =
                    firstRes.Payload.facilityId;
                }
              }
            }
          }


          let secondScreenCallsLength: number = 0;

          // Second screen API Calls
          if (
            this.addressFromSecondScreen &&
            this.addressFromSecondScreen.length
          ) {
            for (let i = 0; i < this.addressFromSecondScreen.length; i++) {
              let secondPayload = this.createAddressAddPayloadForProvider(
                this.addressFromSecondScreen[i]
              );
              this.sharedStateSvc
                .userRegistration(secondPayload)
                .subscribe((secondRes) => {
                  if (secondRes && secondRes.Status === "SUCCESS") {
                    secondScreenCallsLength++;
                    this.MasterAccountId =
                      secondRes.Payload.masterPortalAccountId; // Resonse Master Portal Account Id
                    this.masterFacilityIdSecondScreen =
                      secondRes.Payload.facilityId;
                    this.addressFromSecondScreen[i].Id = secondRes.Payload.facilityId

                    if (secondScreenCallsLength === this.addressFromSecondScreen.length) {
                      this.saveProviderFacilitiesCallsForProvider();
                    }

                  } else {
                    this.toastr.error("Error in saving Additional Addresses");
                  }
                });
            }
          } else {
            this.formData.hideLoader.next(false);
            this.saveProviderFacilitiesCallsForProvider();
          }
        } else {
          this.toastr.error("Error in creating the account");
        }
      },
      (error) => {
        this.formData.hideLoader.next(false);
        this.toastr.error("The username already has portal account.");
      }
      );
  }

  saveProviderFacilitiesCallsForProvider() {
    const thirdPayload = this.createMasterProvidersPayloadForProvider();

    // Third Screen API Calls
    this.sharedStateSvc
      .userRegistration(thirdPayload)
      .subscribe((thirdRes) => {
        if (thirdRes && thirdRes.Status === "SUCCESS") {
          this.formData.hideLoader.next(false);
          this.reqProviders = [];
          this.regNew = false;
          this.additionalAddress = false;
          this.conMessage = true;

        } else {
          this.toastr.error("Error in saving providers");
        }
      },
        (error) => {
          this.formData.hideLoader.next(false);
          this.toastr.error("Error in saving providers");
        }
      );
  }

  createMasterProvidersPayloadForProvider() {
    if (this.addressFromSecondScreen.length > 0) {
      const masterProviderFacilities = this.getMasterProviderFacilitiesForProvider(this.addressFromSecondScreen);
      const filterFirstScreenPayload = { ...this.firstScreenPayload }
      filterFirstScreenPayload.IsNewUser = false;
      delete filterFirstScreenPayload.UserContactDetails
      return {
        ...filterFirstScreenPayload,
        MasterAccountId: this.MasterAccountId,
        Facilities: masterProviderFacilities,
      };
    }
    else {
      return {
        ...this.firstScreenPayload,
        MasterAccountId: this.MasterAccountId,
      };
    }
  }

  getMasterProviderFacilitiesForProvider(provList) {
    let facilityList: any[] = [];

    for (let prov of provList) {
      let facility = {
        PracticeGroup: prov.PracticeName,
        Email: prov.Email,
        Fax: prov.Fax ? prov.Fax.replace(/\D+/g, "") : prov.Fax,
        OfficeName: prov.PracticeName,
        Rank: 1,
        Id: prov.Id,
        Phone: prov.Phone ? prov.Phone.replace(/\D+/g, "") : prov.Phone,
        NPI: prov.facilityNPI ? prov.facilityNPI : null,
        Extension: null,
        Address: {
          City: prov.City,
          Line1: prov.Address1,
          Line2: prov.Address2,
          State: prov.State,
          Zipcode: prov.Zip,
        },
        Contacts: [
        ],
      };

      facilityList.push(facility);
    }

    return facilityList;
  }


  createAddressAddPayloadForProvider(addObj) {
    const filterFirstScreenPayload = { ...this.firstScreenPayload }

    delete filterFirstScreenPayload.PrescriberId;

    filterFirstScreenPayload.IsNewUser = false;

    filterFirstScreenPayload.UserContactDetails[0].Id = this.userContactId;

    return {
      ...filterFirstScreenPayload,
      MasterAccountId: this.MasterAccountId,
      MasterFacility: {
        PracticeGroup: addObj.PracticeName,
        Email: addObj.Email,
        Fax: addObj.Fax ? addObj.Fax.replace(/\D+/g, "") : addObj.Fax,
        OfficeName: addObj.PracticeName,
        Rank: 1,
        Id: null,
        Phone: addObj.Phone ? addObj.Phone.replace(/\D+/g, "") : addObj.Phone,
        PhoneType: "Office",
        Extension: null,
        FacilityType: "practice Office",
        Address: [
          {
            City: addObj.City,
            Line1: addObj.Address1,
            Line2: addObj.Address2,
            State: addObj.State,
            Zipcode: addObj.Zip,
          },
        ],
        Contacts: [
        ],

      },
    };
  }

  // Iveric first page data and payload will be here
  onSubmit(form) {
    this.progressStep1 = true;
    this.progressStep2 = true;
    this.progressStep3 = false;
    this.progressStep4 = false;

    this.addressFromFirstScreen = [];
    this.regNew = false;
    this.additionalAddress = false;
    this.providers = true;
    this.conMessage = false;

    // Public Value
    this.Username = form.value.userName;
    this.Password = form.value.password;
    this.PasswordConfirmation = form.value.confirmPassword;

    this.contactFirstName = form.value.firstName;
    (this.contactSecondName = form.value.secondtName),
      (this.reqPhone = form.value.phone ? form.value.phone.replace(/\D+/g, "") : form.value.phone);
    this.reqFax = form.value.fax ? form.value.fax.replace(/\D+/g, "") : form.value.fax;
    this.reqEmail = form.value.email;

    this.firstScreenPayload = {
      Username: this.userName,
      EmailAddress: this.email,
      Password: this.password,
      PasswordConfirmation: this.confirmPassword,
      Role: {
        // RolePkId: this.roleType[this.userSelected],
        RolePkId: 4
      },
      IsNewUser: true,
      UserContactDetails: [
        {
          Email: this.email,
          FirstName: this.firstName,
          LastName: this.secondtName,
          Phone: this.phone ? this.phone.replace(/\D+/g, "") : this.phone,
          Fax: this.fax ? this.fax.replace(/\D+/g, "") : this.fax
        }
      ]
    };

    this.regNew = false;
    this.additionalAddress = false;
    this.providers = true;
    this.conMessage = false;
  }

  addDefaultFacilities(formData) {
    this.progressStep1 = true;
    this.progressStep2 = true;
    this.progressStep3 = true;
    this.progressStep4 = false;

    // this.secondScreenPayload = {
    //   Username: this.Username,
    //   Password: this.Password,
    //   IsNewUser: false,
    //   PasswordConfirmation: this.PasswordConfirmation,
    //   MasterAccountId: this.MasterAccountId,
    //   MasterFacility: {
    //     PracticeGroup: "Default",
    //     Email: this.reqEmail,
    //     Fax: this.reqFax,
    //     OfficeName: this.practiceGroup,
    //     Rank: 1,
    //     Id: null,
    //     Phone: this.reqPhone,
    //     PhoneType: "Office",
    //     Extension: null,
    //     FacilityType: "Physician Office",
    //     Address: this.regAddress,
    //     Contacts: [
    //       {
    //         Id: null,
    //         Email: this.reqEmail,
    //         Fax: this.reqFax,
    //         FirstName: this.contactFirstName,
    //         LastName: this.contactSecondName,
    //         OfficeContactType: "Office Contact",
    //         Rank: 1,
    //         Title: null,
    //         Phone: this.reqPhone,
    //         Extension: null,
    //       },
    //     ],
    //   },
    // };

    this.regNew = false;
    this.additionalAddress = true;
    this.providers = false;
    this.conMessage = false;
  }

  ignoreAddress() {
    this.regNew = false;
    this.additionalAddress = false;
    this.providers = true;
    this.conMessage = false;
  }

  registrationAddProviders() {
    this.regNew = false;
    this.additionalAddress = false;
    this.providers = true;
    this.conMessage = false;
    this.registerButtonEnabled = true;
  }

  addProviderData(providerData) {
    this.addressforScreen = [];
    this.reqProviders = [];

    this.secondScreenPayload = {
      Username: this.Username,
      Password: this.Password,
      IsNewUser: false,
      PasswordConfirmation: this.PasswordConfirmation,
      MasterAccountId: this.MasterAccountId,
      MasterFacility: {
        PracticeGroup: "Default",
        Email: this.reqEmail,
        Fax: this.reqFax,
        OfficeName: this.practiceGroup,
        Rank: 1,
        Id: null,
        Phone: this.reqPhone,
        PhoneType: "Office",
        Extension: null,
        // FacilityType: "Physician Office",
        Address: this.regAddress,
        Contacts: [
          {
            Id: null,
            Email: this.reqEmail,
            Fax: this.reqFax,
            FirstName: this.contactFirstName,
            LastName: this.contactSecondName,
            OfficeContactType: "Office Contact",
            Rank: 1,
            Title: null,
            Phone: this.reqPhone,
            Extension: null,
          },
        ],
      },
    };

    this.thirdScreenPayload = {
      Username: this.Username,
      Password: this.Password,
      PasswordConfirmation: this.PasswordConfirmation,
      MasterAccountId: this.MasterAccountId,
      PrescriberId: this.prescriberPkId,
      MasterFacility: {
        PracticeGroup: this.practiceGroup,
        Email: this.reqEmail,
        Fax: this.reqFax,
        OfficeName: this.practiceGroup,
        Rank: 1,
        Id: null,
        Phone: this.reqPhone,
        PhoneType: "Office",
        Extension: null,
        FacilityType: "Practice Office",
        Address: [
          {
            City: this.City,
            Line1: this.addressLine1,
            Line2: this.addressLine2,
            State: this.State,
            Zipcode: this.reqZip,
          },
        ],
        Contacts: [
          {
            Email: this.reqEmail,
            Fax: this.reqFax,
            FirstName: this.contactFirstName,
            LastName: this.contactSecondName,
            OfficeContactType: "Office Contact",
            Rank: 1,
            Title: null,
            Phone: this.reqPhone,
            Extension: null,
          },
        ],
      },
      Facilities: this.masterFacilityImportData,
    };

    this.regNew = false;
    // this.additionalAddress = false;
    // this.providers = true;
    this.conMessage = false;
    this.filterTableEnabled = true;
    this.registerButtonEnabled = true;
    this.registrationDone()
  }

   //Iveric Registration starts here SaveAndRegister
  registrationDone() {
    
    this.formData.hideLoader.next(true);
    this.sharedStateSvc
      .userRegistration(this.firstScreenPayload)
      .subscribe((firstRes) => {
        if (firstRes && firstRes.Status === 'SUCCESS') {
          this.MasterAccountId = firstRes.Payload.masterPortalAccountId; // Resonse Master Portal Account Id
          this.MasterFacilityId = firstRes.Payload.facilityId;
          this.userContactId = firstRes.Payload.contactId;

          let keysList = Object.keys(this.allProvidersMasterList);

          for (let provId of keysList) {
            for (let j = 0; j < this.allProvidersMasterList[provId].length; j++) {
              if (this.allProvidersMasterList[provId][j] && this.allProvidersMasterList[provId][j].recordId) {
                if (this.allProvidersMasterList[provId][j].recordId === 1) {
                  this.allProvidersMasterList[provId][j].Id = firstRes.Payload.facilityId;
                }
              }
            }
          }


          let secondScreenCallsLength: number = 0;

          // Second screen API Calls  new Facility registration 
          if (this.addressFromSecondScreen && this.addressFromSecondScreen.length) {
            for (let i = 0; i < this.addressFromSecondScreen.length; i++) {
              let secondPayload = this.createAddressAddPayload(this.addressFromSecondScreen[i]);

              this.sharedStateSvc
                .userRegistration(secondPayload)
                .subscribe((secondRes) => {

                  if (secondRes && secondRes.Status === 'SUCCESS') {
                    secondScreenCallsLength++;
                    this.MasterAccountId = secondRes.Payload.masterPortalAccountId; // Resonse Master Portal Account Id
                    this.masterFacilityIdSecondScreen = secondRes.Payload.facilityId;
                    this.recordIdToFacilityId[this.addressFromSecondScreen[i].recordId] = secondRes.Payload.facilityId;

                    // for (let provId of keysList) {
                    //   for (let j = 0; j < this.allProvidersMasterList[provId].length; j++) {
                    //     if (this.allProvidersMasterList[provId][j] && this.allProvidersMasterList[provId][j].recordId) {
                    //       if (this.allProvidersMasterList[provId][j].recordId === this.addressFromSecondScreen[i].recordId) {
                    //         this.allProvidersMasterList[provId][j].Id = secondRes.Payload.facilityId;
                    //       }
                    //     }
                    //   }
                    // }
                     
                    if (secondScreenCallsLength === this.addressFromSecondScreen.length) {
                      this.saveProviderFacilitiesCalls();
                   
                    }
                  } else {
                    this.toastr.error("Error in saving Additional Addresses");

                  }
                });
            }
          } else {

            this.saveProviderFacilitiesCalls();
          }
        } else {
          this.toastr.error("Error in creating the account");
        }
      },
      (error) => {
        this.formData.hideLoader.next(false);
        this.toastr.error("The username already has portal account.");
      }
      );
  }
   
  //iveric last call for registration
  saveProviderFacilitiesCalls() {
    let thirdScreenCallsLength: number = 0;
    
    // here we will create a payload for association of accounts
    for (let provData of this.facilitiesCallData) {
      let thirdPayload = this.createMasterProvidersPayload(provData);
      // Third Screen API Call
      if (thirdPayload.Facilities.length){
        this.sharedStateSvc
          .userRegistration(thirdPayload)
          .subscribe((thirdRes) => {
            if (thirdRes && thirdRes.Status === "SUCCESS") {
              thirdScreenCallsLength++;

              if (thirdScreenCallsLength === this.facilitiesCallData.length) {
                this.formData.hideLoader.next(false);
                this.reqProviders = [];
                this.regNew = false;
                this.additionalAddress = false;
                this.providers = false;
                this.conMessage = true;
              }
            } else {
              this.toastr.error("Error in saving providers");
              this.formData.hideLoader.next(false);
            }
          },
            (erro) => {
              this.formData.hideLoader.next(false);
              this.toastr.error("Error in saving providers");
            }
          );
      } else { thirdScreenCallsLength++;
        if (thirdScreenCallsLength === this.facilitiesCallData.length) {
          this.formData.hideLoader.next(false);
          this.reqProviders = [];
          this.regNew = false;
          this.additionalAddress = false;
          this.providers = false;
          this.conMessage = true;
        }
      }
    }
  }

  //iveric payload for last Account association calls
  createMasterProvidersPayload(provData) {
    let masterProviderFacilities = this.getMasterProviderFacilities(provData);
    return {
      Username: this.Username,
      Password: this.Password,
      EmailAddress: this.reqEmail,
      PasswordConfirmation: this.PasswordConfirmation,
      MasterAccountId: this.MasterAccountId,
      PrescriberId: provData.PrescriberId,
      IsNewUser: false,
      Facilities: masterProviderFacilities,
    };
  }

  //iveric third call facilites accumulation
  getMasterProviderFacilities(provList) {
    // debugger
    let facilityList: any[] = [];

    for (let prov of provList.Existing) {
      if (prov.isSelected) {
        let facility = {
          PracticeGroup: prov.GroupName ? prov.GroupName : "",
          Email: this.reqEmail,
          Fax: this.reqFax,
          OfficeName: prov.Name ? prov.Name : "",
          Rank: 1,
          Id: prov.Id,
          Phone: this.reqPhone,
          NPI: prov.facilityNPI ? prov.facilityNPI : null,
          Extension: null,
          Address: {
            City: prov.City,
            Line1: prov.Address1,
            Line2: prov.Address2,
            State: prov.State,
            Zipcode: prov.Zip,
          },
          Contacts: [
          ],
        }; 
        facilityList.push(facility);
      }
    }

    //in this get the id From recordIdToFacilitiy object
    for (let prov of provList.New) {
      if (prov.isSelected) {
        let facility = {
          PracticeGroup: prov.GroupName ? prov.GroupName : "",
          Email: this.reqEmail,
          Fax: this.reqFax,
          OfficeName: prov.Name ? prov.Name : "",
          Rank: 1,
          Id: this.recordIdToFacilityId[prov.recordId],
          Phone: this.reqPhone,
          NPI: prov.facilityNPI ? prov.facilityNPI : null,
          Extension: null,
          Address: {
            City: prov.City,
            Line1: prov.Address1,
            Line2: prov.Address2,
            State: prov.State,
            Zipcode: prov.Zip,
          },
          Contacts: [
          ],
        };

        facilityList.push(facility);
      }
    }

    return facilityList;
  }
  
  // iveric Create payload for new facility registration
  createAddressAddPayload(addObj) {
    const firstPayload = {
      ...this.firstScreenPayload,
      MasterAccountId: this.MasterAccountId,
      IsNewUser: false,
    }

    firstPayload.UserContactDetails[0].Id = this.userContactId;

    return {
      ...firstPayload,
      MasterFacility: {
        PracticeGroup: addObj.PracticeName,
        Email: addObj.Email,
        Fax: addObj.Fax ? addObj.Fax.replace(/\D+/g, "") : addObj.Fax,
        OfficeName: addObj.PracticeName,
        Rank: 1,
        Id: null,
        Phone: addObj.Phone ? addObj.Phone.replace(/\D+/g, "") : addObj.Phone,
        PhoneType: "Office",
        Extension: null,
        FacilityType: "Practice Office",
        Address: [
          {
            City: addObj.City,
            Line1: addObj.Address1,
            Line2: addObj.Address2,
            State: addObj.State,
            Zipcode: addObj.Zip,
          },
        ],
        Contacts: [
        ],

      },
    };
  }

  addDefaultProviderAddress() {
    const defaultadd = {
      Address1: this.addressLine1,
      Address2: this.addressLine2,
      City: this.City,
      State: this.State,
      Name: this.practiceGroup,
      Zip: this.reqZip,
    };

    if (this.isChecked == false) {
      this.addressforScreen.unshift(defaultadd);
    } else if (this.isChecked == true) {
      this.addressforScreen.shift();
    }
  }

  deleteProviders(rowData) {
    let postion = this.addressforScreen.indexOf(rowData);
    this.addressforScreen.splice(postion, 1);
  }

  //iveric add/delete facility
  getRowData(event,PI,ind, data, NPI) {
    // add case
    if (event.target.checked){
      
         if (this.facilitiesCallData[PI].NPI === NPI){

          if (data.recordId){
            this.facilitiesCallData[PI].New = [data, ...this.facilitiesCallData[PI].New];
          }
          else { 
            this.facilitiesCallData[PI].Existing = [data, ...this.facilitiesCallData[PI].Existing];
          }
        }
       const index = this.newProvidersWithFacilities[PI].Facilities.indexOf(data);
       this.newProvidersWithFacilities[PI].Facilities[index].isSelected = true;
      this.checkedFacilityCount = [...this.checkedFacilityCount, this.newProvidersWithFacilities[PI].Facilities[ind]];
    } else {
      // remove case
      // for (var obj of this.facilitiesCallData) {
      if (this.facilitiesCallData[PI].NPI === NPI) {

          if (data.recordId) {
            let index = this.facilitiesCallData[PI].New.indexOf(newObj => newObj.recordId === data.recordId);
            this.facilitiesCallData[PI].New.splice(index,1);
          }
          else {
            let index = this.facilitiesCallData[PI].New.indexOf(newObj => newObj.Id === data.Id);
            this.facilitiesCallData[PI].Existing.splice(index,1);
          }
        }
      // }
      const indexx = this.newProvidersWithFacilities[PI].Facilities.indexOf(data);
      this.newProvidersWithFacilities[PI].Facilities[indexx].isSelected = false;
      const index = this.checkedFacilityCount.indexOf(this.newProvidersWithFacilities[PI].Facilities[ind]);
      this.checkedFacilityCount.splice(index,1);
    }
    // this.allProvidersMasterList[this.prescriberPkId][data].isSelected =
    //   event.target.checked;
    // this.modalSubmitDisableHandler();
    // We have to Make the changes in the array of FacilitiesCallData
    // console.log(this.facilitiesCallData,"facilitiesCallData");
  }

  modalSubmitDisableHandler() {
    const selectedItemArry = this.allProvidersMasterList[this.prescriberPkId].filter(data => data.isSelected);
    const isItemSelected = selectedItemArry.length == 0;

    this.modalSubmitDisable = {
      ...this.modalSubmitDisable,
      [this.prescriberPkId]: isItemSelected
    }
  }

  // iveric delete newly added facility
  deleteAddress(rowData) {
    // debugger
    let postion = this.addressFromSecondScreen.indexOf(rowData);
    this.addressFromSecondScreen.splice(postion, 1);

    // let keysList = Object.keys(this.allProvidersMasterList);

    // for (let provId of keysList) {
    //   for (let i = 0; i < this.allProvidersMasterList[provId].length; i++) {
    //     if (
    //       this.allProvidersMasterList[provId][i] &&
    //       this.allProvidersMasterList[provId][i].recordId &&
    //       this.allProvidersMasterList[provId][i].recordId === rowData.recordId
    //     ) {
    //       this.allProvidersMasterList[provId].splice(i, 1);
    //     }
    //   }
    // }

    //delete it from the facilitiesCallData of each object, newProvidersWithFacilities
    //from newProvidersWithFacilities
    for(let obj of this.newProvidersWithFacilities){
      let index = obj.Facilities.findIndex(facility => facility.recordId === rowData.recordId);
      if(index != -1)
       obj.Facilities.splice(index,1);
    }

    for(let obj of this.facilitiesCallData){
      let index = obj.New.findIndex(obj2 => obj2.recordId === rowData.recordId);
      if(index != -1){
        obj.New.splice(index,1);
      }
    } 

    const index = this.checkedFacilityCount.indexOf(obj => obj.recordId === rowData.recordId);
    this.checkedFacilityCount.splice(index, 1);
    
  }

  onEditAddressClick(rowData) {
    this.address1 = rowData.Address1;
    this.address2 = rowData.Address2;
    this.cityReg = rowData.City;
    this.stateReg = rowData.State;
    this.zipReg = rowData.Zip;
    this.associatePhone = rowData.Phone;
    this.associateFax = rowData.Fax;
    this.associateEmail = rowData.Email;
    this.practiceName = rowData.PracticeName;

    this.onAddEditRecordId = rowData.recordId;

    this.addressFromSecondScreen.forEach((item) => (item.IsEditRow = false));
    let index = this.addressFromSecondScreen.findIndex(
      (item) => item.recordId === rowData.recordId
    );
    if (index != -1) {
      this.addressFromSecondScreen[index].IsEditRow = true;
      this.isFacilityEditingEnable = true
    }
  }

  cancelAddressUpdate() {
    this.addressFromSecondScreen.forEach((item) => (item.IsEditRow = false));
    this.isFacilityEditingEnable = false;

    this.onAddEditRecordId = null;
    this.address1 = "";
    this.address2 = "";
    this.cityReg = "";
    this.stateReg = "";
    this.zipReg = "";
    this.practiceName = "";
    this.associatePhone = "";
    this.associateFax = "";
    this.associateEmail = "";
  }

  editAddressUpdate() {
    let postion = this.addressFromSecondScreen.findIndex(
      (item) => item.recordId === this.onAddEditRecordId
    );

    if (postion >= 0) {
      this.addressFromSecondScreen[postion].Address1 = this.address1;
      this.addressFromSecondScreen[postion].Address2 = this.address2;
      this.addressFromSecondScreen[postion].City = this.cityReg;
      this.addressFromSecondScreen[postion].State = this.stateReg;
      this.addressFromSecondScreen[postion].Zip = this.zipReg;
      this.addressFromSecondScreen[postion].PracticeName = this.practiceName;
      this.addressFromSecondScreen[postion].GroupName = this.practiceName;
      this.addressFromSecondScreen[postion].Name = this.practiceName;
      this.addressFromSecondScreen[postion].Phone = this.associatePhone;
      this.addressFromSecondScreen[postion].Fax = this.associateFax;
      this.addressFromSecondScreen[postion].Email = this.associateEmail;
      this.addressFromSecondScreen[postion].IsEditRow = false;
      let keysList = Object.keys(this.allProvidersMasterList);

      for (let provId of keysList) {
        for (let i = 0; i < this.allProvidersMasterList[provId].length; i++) {
          if (
            this.allProvidersMasterList[provId][i] &&
            this.allProvidersMasterList[provId][i].recordId &&
            this.allProvidersMasterList[provId][i].recordId ===
            this.onAddEditRecordId
          ) {
            this.allProvidersMasterList[provId][i].Address1 = this.address1;
            this.allProvidersMasterList[provId][i].Address2 = this.address2;
            this.allProvidersMasterList[provId][i].City = this.cityReg;
            this.allProvidersMasterList[provId][i].State = this.stateReg;
            this.allProvidersMasterList[provId][i].Zip = this.zipReg;
            this.allProvidersMasterList[provId][i].PracticeName =
              this.practiceName;
            
            this.allProvidersMasterList[provId][i].Phone = this.associatePhone;
            this.allProvidersMasterList[provId][i].Fax = this.associateFax;
            this.allProvidersMasterList[provId][i].Email = this.associateEmail;
            this.allProvidersMasterList[provId][i].IsEditRow = false;
          }
        }
      }

      //iveric work updtae the data in newProvidersWithFacility and FacilityCallData

      for (let obj of this.newProvidersWithFacilities) {
        let index = obj.Facilities.findIndex(facility => facility.recordId === this.addressFromSecondScreen[postion].recordId);
        if (index != -1)
          obj.Facilities[index] = this.addressFromSecondScreen[postion];
      }

      for (let obj of this.facilitiesCallData) {
        let index = obj.New.findIndex(obj2 => obj2.recordId === this.addressFromSecondScreen[postion].recordId);
        if (index != -1) {
          obj.New[index] = this.addressFromSecondScreen[postion];
        }
      }

      this.isFacilityEditingEnable = false;
    }

    this.onAddEditRecordId = null;
    this.address1 = "";
    this.address2 = "";
    this.cityReg = "";
    this.stateReg = "";
    this.zipReg = "";
    this.practiceName = "";
    this.associatePhone = "";
    this.associateFax = "";
    this.associateEmail = "";
  }

  handleInputNumber(event) {
    const name = event.target.name;
    const value = event.target.value

    if (name == 'associatePhone') {
      this.associatePhone = value
    }

    if (name == 'associateFax') {
      this.associateFax = value
    }

    if (name == 'addPhone') {
      this.addPhone = value
    }

    if (name == 'addFax') {
      this.addFax = value
    }
  }

  // Provider Screen Logic
  addProvidersReq(hcpNPI, hcpFirstName, hcpLastName, providerForm) {
    this.reqProviders = [];
    this.formData.hideLoader.next(true);
    console.log(this.addedPrescriberList,"addedPrescriberList");
    const searchIndex = this.addedPrescriberList.findIndex((m) => m.NPI == hcpNPI);
    if(searchIndex == -1){
    this.sharedStateSvc
      .getProvidersDetails(hcpNPI, hcpFirstName, hcpLastName)
      .subscribe(
        (res) => {
          if (res && res.Status === "SUCCESS" && res.Payload[0]) {
            // this.filterTableEnabled = true;
            this.addedPrescribers = true;
            this.prescriberPkId = res.Payload[0].Id;
            this.reqProviders.push(res.Payload[0]);
            this.addedPrescriberList=[...this.addedPrescriberList,res.Payload[0]]
     
            let existingFacilities = res.Payload[0].Facilities;

            for (let i = 0; i < existingFacilities.length; i++) {
              existingFacilities[i]["isSelected"] = false;
              existingFacilities[i]["providerId"] = res.Payload[0].Id;
              existingFacilities[i]["NPI"] = res.Payload[0].NPI;
              existingFacilities[i]["PrescriberFirstName"] =
                res.Payload[0].PrescriberFirstName;
              existingFacilities[i]["PrescriberLastName"] =
                res.Payload[0].PrescriberLastName;
            }

            res.Payload[0].Facilities = existingFacilities;
            this.newProvidersWithFacilities.push(res.Payload[0]);
            this.facilitiesCallData.push({ NPI: res.Payload[0].NPI, PrescriberId: res.Payload[0].Id , Existing: [], New: [] });

            //not in use for iveric
            // for (let i = 0; i < this.addressFromFirstScreen.length; i++) {
            //   this.addressFromFirstScreen[i]["providerId"] = res.Payload[0].Id;
            //   this.addressFromFirstScreen[i]["NPI"] = res.Payload[0].NPI;
            //   this.addressFromFirstScreen[i]["PrescriberFirstName"] =
            //     res.Payload[0].PrescriberFirstName;
            //   this.addressFromFirstScreen[i]["PrescriberLastName"] =
            //     res.Payload[0].PrescriberLastName;
            // }
             
            // //not in use of Second screen
            // for (let i = 0; i < this.addressFromSecondScreen.length; i++) {
            //   this.addressFromSecondScreen[i]["providerId"] = res.Payload[0].Id;
            //   this.addressFromSecondScreen[i]["NPI"] = res.Payload[0].NPI;
            //   this.addressFromSecondScreen[i]["PrescriberFirstName"] =
            //     res.Payload[0].PrescriberFirstName;
            //   this.addressFromSecondScreen[i]["PrescriberLastName"] =
            //     res.Payload[0].PrescriberLastName;
            // }

            const nameObj = {
              ProviderId: res.Payload[0].Id,
              FirstName: res.Payload[0].PrescriberFirstName,
              LastName: res.Payload[0].PrescriberLastName,
            }
            
            this.allProvidersName = {
              ...this.allProvidersName,
              [nameObj.ProviderId]: {
                name: `${nameObj.FirstName} ${nameObj.LastName}`,
              }
            }

            this.addressforScreen = [];

            // this.addressFromFirstScreen.forEach((val) =>
            //   this.addressforScreen.push(Object.assign({}, val))
            // );
            // this.addressFromSecondScreen.forEach((val) =>
            //   this.addressforScreen.push(Object.assign({}, val))
            // );
            // existingFacilities.forEach((val) =>
            //   this.addressforScreen.push(Object.assign({}, val))
            // );

            let keysList = Object.keys(this.allProvidersMasterList);

            if (keysList.indexOf(this.prescriberPkId.toString()) < 0) {
              this.allProvidersMasterList[this.prescriberPkId] =
                this.addressforScreen;
            }

            this.practiceAddress = res.Payload[0].Facilities;
            this.formData.hideLoader.next(false);
            this.isIncorrectNPI = false;
            this.modalSubmitDisableHandler();
            providerForm.form.reset()
          }
        },
        (error) => {
          if (window.screen.width <= 480) {
            this.toastr.error(`One or more pieces of information entered do not match our records. Please try again or contact us for additional assistance.`);
          }
          this.formData.hideLoader.next(false);
          this.isIncorrectNPI = true
        }
      );
    } else {
      this.toastr.error(`This provider is already Added`);
      providerForm.form.reset();
      this.formData.hideLoader.next(false);
    } 
    // this.hcpNPI = "";
    // this.hcpFirstName = "";
    // this.hcpLastName = "";
    // this.taxIdReq = "";
    // this.ptan = "";
  }
  

  deleteRow(pro: any) {
    // debugger
    let index = this.addedPrescriberList.indexOf(pro);
    if (index !== -1) {
      let temp:any[] = [...this.addedPrescriberList];
      this.addedPrescriberList=[];
      temp.splice(index, 1);
      this.addedPrescriberList=[...temp];
    }
      this.newProvidersWithFacilities.splice(index,1);
  }

  prev0() {
    this.newReg0 = true;
    this.regNew = false;
    this.additionalAddress = false;
    this.providers = false;
    this.conMessage = false;

    this.progressStep1 = true;
    this.progressStep2 = false;
    this.progressStep3 = false;
    this.progressStep4 = false;
  }

  prev1() {
    this.regNew = true;
    this.additionalAddress = false;
    this.providers = false;
    this.conMessage = false;

    this.progressStep1 = true;
    this.progressStep2 = false;
    this.progressStep3 = false;
    this.progressStep4 = false;
  }

  addFacilities() {
    this.regNew = false;
    this.additionalAddress = false;
    this.providers = true;
    this.conMessage = false;
  }
  prev2() {
    this.regNew = false;
    this.additionalAddress = false;
    this.providers = true;
    this.conMessage = false;

    this.progressStep1 = true;
    this.progressStep2 = true;
    this.progressStep3 = false;
    this.progressStep4 = false;
  }
  addProviders() {
    this.regNew = false;
    this.additionalAddress = false;
    this.providers = false;
    this.conMessage = true;
  }
  prev3() {
    this.regNew = false;
    this.additionalAddress = false;
    this.providers = true;
    this.conMessage = false;
  }

  backToLogin() {
    this.router.navigate(["/login"]);
  }

  toggleNewPassword(){
    this.newPasswordShowPasswordIcon = !this.newPasswordShowPasswordIcon;
  }
  toggleConfirmPassword(){
    this.confirmPasswordShowPasswordIcon = !this.confirmPasswordShowPasswordIcon;
  }

  //Add new Facilities Iveric
  addAddress(
    practiceName,
    associatePhone,
    associateFax,
    associateEmail,
    address1,
    address2,
    city,
    state,
    zip
  ) {
    const addressObject = {
      Line1: address1,
      Line2: address2,
      City: city,
      State: state,
      Zipcode: zip,
    };
    const addressObjectProviders = {
      Address1: address1,
      Address2: address2,
      City: city,
      State: state,
      Zip: zip,
      Name: practiceName,
      Id: this.masterFacilityIdSecondScreen,
      isSelected: true,
      recordId: this.facAddCount,
      GroupName: practiceName,
      PracticeName: practiceName,
      Phone: associatePhone,
      Fax: associateFax,
      Email: associateEmail,
      IsEditRow: false,
    };


    //   this.allProvidersMasterList[0] = [...this.allProvidersMasterList[0], addressObjectProviders];
    //  console.log(this.allProvidersMasterList[0],"heheheh")

    // this.allProvidersMasterList.forEach(provider => {
    //   provider.data={ ...addressObjectProviders};
    // });
    // let arr = Object.keys(this.allProvidersMasterList);
    // arr.forEach((k)=>{
    //   this.allProvidersMasterList[k].push(addressObjectProviders);
    // })

    this.addressFromSecondScreen.push(addressObjectProviders);
    //also add this obj in Facility of all newProviderAdded
    for(let obj of this.newProvidersWithFacilities){
      obj.Facilities = [{...addressObjectProviders}, ...obj.Facilities];
    }

    for(let obj of this.facilitiesCallData){
      obj.New = [addressObjectProviders, ...obj.New];
    }

    this.checkedFacilityCount = [...this.checkedFacilityCount, addressObjectProviders];
    

    this.facAddCount++;
    this.address1 = "";
    this.address2 = "";
    this.cityReg = "";
    this.stateReg = "";
    this.zipReg = "";
  }

  editProvider(e, provId) {
    e.stopPropagation();

    if (provId) {
      this.filterTableEnabled = true;
      this.prescriberPkId = provId;
      this.modalSubmitDisableHandler();
    }
  }

  deleteProvider(event, key) {
    event.stopPropagation();

    delete this.allProvidersMasterList[key];
    this.provIdDelete = null;
  }

  // checkUserName(inputUserName) {
  //   this.sharedStateSvc.checkIfUserNameUsed(inputUserName).then((resp) => {
  //     if (!resp.Payload) {
  //       this.isUserName = true;
  //     } else {
  //       this.isUserName = false;
  //     }
  //   });
  // }

  checkFacilityNPI(facilityNPI) {
    this.isOrgNPIExists = false;

    if (facilityNPI) {
      this.sharedStateSvc
        .checkNpivailable(facilityNPI)
        .then((resp) => {
          if (
            resp &&
            resp.Status === "SUCCESS" &&
            resp.Payload &&
            resp.Payload.MasterFacility
          ) {
            let autoFilled = resp.Payload.MasterFacility;

            if (autoFilled.NPI == facilityNPI) {

              this.isOrgNPIExists = true;

              alert(
                "There is already an account created with the provided NPI.\nPlease contact your administrator if you are trying to get access.\nIf you are trying to reset your password, please select Forgot Password on the login screen.\nIf you need further assistance, contact us at:\n\n• APOKYN: 1-877-727-6596, OPTION 3\n• MYOBLOC: 1-888-461-2255, OPTION 3"
              );
            }
          } else {
          }
        })
        .catch((erorrr) => {
        });
    }
  }

  trimIt(event) {
    const value = event.target.value;
    const name = event.target.name;

    if (name == 'practiceName') {
      this.practiceName = value.trim()
    }

    if (name == 'addPracticeName') {
      this.addPracticeName = value.trim()
    }

    if (name == 'firstName') {
      this.firstName = value.trim()
    }

    if (name == 'secondtName') {
      this.secondtName = value.trim()
    }

    if (name == 'hcpFirstName') {
      this.hcpFirstName = value.trim()
    }

    if (name == 'hcpLastName') {
      this.hcpLastName = value.trim()
    }
  }

  validateField(event) {
    const value = event.target.value;
    const name = event.target.name;

    if (name == 'firstName') {
      this.firstName = value.trim()
      this.isFirstNameError = true;

    } else if (name == 'lastName') {
      this.lastName = value.trim()
      this.isLastNameError = true;

    } else if (name == 'phone') {
      this.phone = value.trim()
      this.isPhoneError = true;

    } else if (name == 'fax') {
      this.fax = value.trim()
      this.isFaxError = true;

    } else if (name == 'email') {
      this.email = value.trim()
      this.isEmailError = true;
    }
  }

  validFirstName(event) {
    let initalValue = event.target.value;

    if (event.target.name == 'practiceName') {
      this.practiceName = initalValue.replace(/[^a-zA-Z]*/g, "")
    }

    if (event.target.name == 'firstName') {
      this.firstName = initalValue.replace(/[^a-zA-Z]*/g, "")
    }
    if (initalValue !== event.target.value) {
      event.stopPropagation();
      this.firstName = event.target.value;
    }
  }

  validLastName(event) {
    let initalValue = event.target.value;
    event.target.value = initalValue.replace(/[^a-zA-Z]*/g, "");
    if (initalValue !== event.target.value) {
      event.stopPropagation();
      this.secondtName = event.target.value;
    }
  }

  validHCPName(event) {
    let initalValue = event.target.value;
    event.target.value = initalValue.replace(/[^a-zA-Z]*/g, "");
    if (initalValue !== event.target.value) {
      event.stopPropagation();
      this.hcpFirstName = event.target.value;
    }
  }
  validHCPLastName(event) {
    let initalValue = event.target.value;
    event.target.value = initalValue.replace(/[^a-zA-Z]*/g, "");
    if (initalValue !== event.target.value) {
      event.stopPropagation();
      this.hcpLastName = event.target.value;
    }
  }

  open(content, url, page, fileName) {
    this.contentURL = url;
    this.page = page;
    this.currentFileName = fileName;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    }, (reason) => {
    })
  }

  downloadFile(): void {
    this.sharedStateSvc.downloadFile(this.contentURL, this.currentFileName);
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }
  SendChoosePrescriberEvent() {
    this.googleAnalytics.eventEmitter("click_on_Prescriber", "Registration", "", "click", 10);
  }
  SendChooseHealthcareProfessionalEvent() {
    this.googleAnalytics.eventEmitter("click_on_healthcare_profession", "Registration", "", "click", 11);
  }
  SendChooseOthersEvent() {
    this.googleAnalytics.eventEmitter("click_on_others", "Registration", "", "click", 12);
  }

}
